export default function ContactSection() {
  return (
    <footer className="relative w-full bg-background-950 py-24 md:py-32 px-8 md:px-16 lg:px-24 xl:px-32">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-20">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 border border-foreground-50/20 flex items-center justify-center">
                <div className="w-2 h-2 bg-foreground-50/40"></div>
              </div>
            </div>
            <p className="text-sm text-foreground-50/40 leading-relaxed">
              Professional engineering for the iOS platform and related technologies.
            </p>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-foreground-50/30 font-medium mb-6">
              Contact
            </h4>
            <div className="space-y-3">
              <p className="text-sm text-foreground-50/70">Info@femansystems.com</p>
              <p className="text-sm text-foreground-50/70">+386 70111209</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-foreground-50/30 font-medium mb-6">
              Address
            </h4>
            <div className="space-y-1">
              <p className="text-sm text-foreground-50/70">Rakitna 275A</p>
              <p className="text-sm text-foreground-50/70">1352 Preserje</p>
              <p className="text-sm text-foreground-50/70">Slovenia</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-foreground-50/30 font-medium mb-6">
              Focus
            </h4>
            <div className="space-y-1">
              <p className="text-sm text-foreground-50/70">iOS Platform</p>
              <p className="text-sm text-foreground-50/70">Clean Architecture</p>
              <p className="text-sm text-foreground-50/70">Performance Engineering</p>
              <p className="text-sm text-foreground-50/70">System Design</p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground-50/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-50/25">
              &copy; {new Date().getFullYear()} All rights reserved.
            </p>
            <p className="text-xs text-foreground-50/25">
              Preserje, Slovenia
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}